module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "element element-container-single element-non-bodymatter element-type-toc toc-with-volume-author",
    attrs: {
      "epub:type": "toc",
      "id": "table-of-contents",
      "role": "doc-toc"
    }
  }, [_c('div', {
    staticClass: "toc-heading"
  }, [_c('h1', {
    staticClass: "toc-title"
  }, [_vm._v("Contents")])]), _vm._v(" "), _c('div', {
    staticClass: "toc-contents"
  }, [_c('div', {
    staticClass: "toc-frontmatter-group"
  }, [_c('div', {
    staticClass: "toc-item toc-item-element-non-bodymatter toc-item-element-type-introduction has-no-leading-number has-no-children has-no-page-number"
  }, [_c('p', {
    staticClass: "element-title"
  }, [_c('a', {
    attrs: {
      "href": "#/introduction"
    }
  }, [_c('span', {
    staticClass: "element-title-text"
  }, [_vm._v("Introduction")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-bodymatter-group"
  }, [_c('div', {
    staticClass: "toc-volume-group has-volume-author has-no-children"
  }, [_c('div', {
    staticClass: "toc-item toc-item-element-bodymatter toc-item-element-type-volume has-no-leading-number has-no-children has-no-page-number"
  }, [_c('p', {
    staticClass: "volume-author"
  }, [_vm._v("Jonathan Maberry")]), _vm._v(" "), _c('p', {
    staticClass: "element-title"
  }, [_c('a', {
    attrs: {
      "href": "#/vol001"
    }
  }, [_c('span', {
    staticClass: "element-title-text"
  }, [_vm._v("Gavin Funke’s Monster Movie Marathon")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-volume-group has-volume-author has-no-children"
  }, [_c('div', {
    staticClass: "toc-item toc-item-element-bodymatter toc-item-element-type-volume has-no-leading-number has-no-children has-no-page-number"
  }, [_c('p', {
    staticClass: "volume-author"
  }, [_vm._v("Luciano Marano")]), _vm._v(" "), _c('p', {
    staticClass: "element-title"
  }, [_c('a', {
    attrs: {
      "href": "#/vol002"
    }
  }, [_c('span', {
    staticClass: "element-title-text"
  }, [_vm._v("Flickering Dusk of the Video God")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-volume-group has-volume-author has-no-children"
  }, [_c('div', {
    staticClass: "toc-item toc-item-element-bodymatter toc-item-element-type-volume has-no-leading-number has-no-children has-no-page-number"
  }, [_c('p', {
    staticClass: "volume-author"
  }, [_vm._v("David Gerrold")]), _vm._v(" "), _c('p', {
    staticClass: "element-title"
  }, [_c('a', {
    attrs: {
      "href": "#/vol003"
    }
  }, [_c('span', {
    staticClass: "element-title-text"
  }, [_vm._v("Michael Thinks the House Is Haunted")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-volume-group has-volume-author has-no-children"
  }, [_c('div', {
    staticClass: "toc-item toc-item-element-bodymatter toc-item-element-type-volume has-no-leading-number has-no-children has-no-page-number"
  }, [_c('p', {
    staticClass: "volume-author"
  }, [_vm._v("Jesse Sprague")]), _vm._v(" "), _c('p', {
    staticClass: "element-title"
  }, [_c('a', {
    attrs: {
      "href": "#/vol004"
    }
  }, [_c('span', {
    staticClass: "element-title-text"
  }, [_vm._v("Atropos Green")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-volume-group has-volume-author has-no-children"
  }, [_c('div', {
    staticClass: "toc-item toc-item-element-bodymatter toc-item-element-type-volume has-no-leading-number has-no-children has-no-page-number"
  }, [_c('p', {
    staticClass: "volume-author"
  }, [_vm._v("C.H. Hung")]), _vm._v(" "), _c('p', {
    staticClass: "element-title"
  }, [_c('a', {
    attrs: {
      "href": "#/vol005"
    }
  }, [_c('span', {
    staticClass: "element-title-text"
  }, [_vm._v("Last Sunset Home")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-volume-group has-volume-author has-no-children"
  }, [_c('div', {
    staticClass: "toc-item toc-item-element-bodymatter toc-item-element-type-volume has-no-leading-number has-no-children has-no-page-number"
  }, [_c('p', {
    staticClass: "volume-author"
  }, [_vm._v("Kevin Pettway")]), _vm._v(" "), _c('p', {
    staticClass: "element-title"
  }, [_c('a', {
    attrs: {
      "href": "#/vol006"
    }
  }, [_c('span', {
    staticClass: "element-title-text"
  }, [_vm._v("Love Your Mother")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-volume-group has-volume-author has-no-children"
  }, [_c('div', {
    staticClass: "toc-item toc-item-element-bodymatter toc-item-element-type-volume has-no-leading-number has-no-children has-no-page-number"
  }, [_c('p', {
    staticClass: "volume-author"
  }, [_vm._v("David Boop")]), _vm._v(" "), _c('p', {
    staticClass: "element-title"
  }, [_c('a', {
    attrs: {
      "href": "#/vol007"
    }
  }, [_c('span', {
    staticClass: "element-title-text"
  }, [_vm._v("Progress Grows Out of Motion")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-volume-group has-volume-author has-no-children"
  }, [_c('div', {
    staticClass: "toc-item toc-item-element-bodymatter toc-item-element-type-volume has-no-leading-number has-no-children has-no-page-number"
  }, [_c('p', {
    staticClass: "volume-author"
  }, [_vm._v("Julie Frost")]), _vm._v(" "), _c('p', {
    staticClass: "element-title"
  }, [_c('a', {
    attrs: {
      "href": "#/vol008"
    }
  }, [_c('span', {
    staticClass: "element-title-text"
  }, [_vm._v("When the Shift Hits the Fan")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-volume-group has-volume-author has-no-children"
  }, [_c('div', {
    staticClass: "toc-item toc-item-element-bodymatter toc-item-element-type-volume has-no-leading-number has-no-children has-no-page-number"
  }, [_c('p', {
    staticClass: "volume-author"
  }, [_vm._v("Shannon Fox")]), _vm._v(" "), _c('p', {
    staticClass: "element-title"
  }, [_c('a', {
    attrs: {
      "href": "#/vol009"
    }
  }, [_c('span', {
    staticClass: "element-title-text"
  }, [_vm._v("Hyde Park")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-volume-group has-volume-author has-no-children"
  }, [_c('div', {
    staticClass: "toc-item toc-item-element-bodymatter toc-item-element-type-volume has-no-leading-number has-no-children has-no-page-number"
  }, [_c('p', {
    staticClass: "volume-author"
  }, [_vm._v("Brendan Mallory")]), _vm._v(" "), _c('p', {
    staticClass: "element-title"
  }, [_c('a', {
    attrs: {
      "href": "#/vol010"
    }
  }, [_c('span', {
    staticClass: "element-title-text"
  }, [_vm._v("Make Me a Star")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-volume-group has-volume-author has-no-children"
  }, [_c('div', {
    staticClass: "toc-item toc-item-element-bodymatter toc-item-element-type-volume has-no-leading-number has-no-children has-no-page-number"
  }, [_c('p', {
    staticClass: "volume-author"
  }, [_vm._v("Linda Maye Adams")]), _vm._v(" "), _c('p', {
    staticClass: "element-title"
  }, [_c('a', {
    attrs: {
      "href": "#/vol011"
    }
  }, [_c('span', {
    staticClass: "element-title-text"
  }, [_vm._v("Alien Pizza")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-volume-group has-volume-author has-no-children"
  }, [_c('div', {
    staticClass: "toc-item toc-item-element-bodymatter toc-item-element-type-volume has-no-leading-number has-no-children has-no-page-number"
  }, [_c('p', {
    staticClass: "volume-author"
  }, [_vm._v("Sam Knight")]), _vm._v(" "), _c('p', {
    staticClass: "element-title"
  }, [_c('a', {
    attrs: {
      "href": "#/vol012"
    }
  }, [_c('span', {
    staticClass: "element-title-text"
  }, [_vm._v("Whoever Writes Monsters")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-volume-group has-volume-author has-no-children"
  }, [_c('div', {
    staticClass: "toc-item toc-item-element-bodymatter toc-item-element-type-volume has-no-leading-number has-no-children has-no-page-number"
  }, [_c('p', {
    staticClass: "volume-author"
  }, [_vm._v("Hailey Piper")]), _vm._v(" "), _c('p', {
    staticClass: "element-title"
  }, [_c('a', {
    attrs: {
      "href": "#/vol013"
    }
  }, [_c('span', {
    staticClass: "element-title-text"
  }, [_vm._v("Toad Man, Toad Man")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-volume-group has-volume-author has-no-children"
  }, [_c('div', {
    staticClass: "toc-item toc-item-element-bodymatter toc-item-element-type-volume has-no-leading-number has-no-children has-no-page-number"
  }, [_c('p', {
    staticClass: "volume-author"
  }, [_vm._v("Rick Wilber")]), _vm._v(" "), _c('p', {
    staticClass: "element-title"
  }, [_c('a', {
    attrs: {
      "href": "#/vol014"
    }
  }, [_c('span', {
    staticClass: "element-title-text"
  }, [_vm._v("False Bay")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-volume-group has-volume-author has-no-children"
  }, [_c('div', {
    staticClass: "toc-item toc-item-element-bodymatter toc-item-element-type-volume has-no-leading-number has-no-children has-no-page-number"
  }, [_c('p', {
    staticClass: "volume-author"
  }, [_vm._v("Steve Rasnic Tem")]), _vm._v(" "), _c('p', {
    staticClass: "element-title"
  }, [_c('a', {
    attrs: {
      "href": "#/vol015"
    }
  }, [_c('span', {
    staticClass: "element-title-text"
  }, [_vm._v("Z Is for Zombie")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-volume-group has-volume-author has-no-children"
  }, [_c('div', {
    staticClass: "toc-item toc-item-element-bodymatter toc-item-element-type-volume has-no-leading-number has-no-children has-no-page-number"
  }, [_c('p', {
    staticClass: "volume-author"
  }, [_vm._v("Ben Monroe")]), _vm._v(" "), _c('p', {
    staticClass: "element-title"
  }, [_c('a', {
    attrs: {
      "href": "#/vol016"
    }
  }, [_c('span', {
    staticClass: "element-title-text"
  }, [_vm._v("Vinegar Syndrome")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-volume-group has-volume-author has-no-children"
  }, [_c('div', {
    staticClass: "toc-item toc-item-element-bodymatter toc-item-element-type-volume has-no-leading-number has-no-children has-no-page-number"
  }, [_c('p', {
    staticClass: "volume-author"
  }, [_vm._v("Charles Maclay")]), _vm._v(" "), _c('p', {
    staticClass: "element-title"
  }, [_c('a', {
    attrs: {
      "href": "#/vol017"
    }
  }, [_c('span', {
    staticClass: "element-title-text"
  }, [_vm._v("Beer with Friends")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-volume-group has-volume-author has-no-children"
  }, [_c('div', {
    staticClass: "toc-item toc-item-element-bodymatter toc-item-element-type-volume has-no-leading-number has-no-children has-no-page-number"
  }, [_c('p', {
    staticClass: "volume-author"
  }, [_vm._v("Irene Radford")]), _vm._v(" "), _c('p', {
    staticClass: "element-title"
  }, [_c('a', {
    attrs: {
      "href": "#/vol018"
    }
  }, [_c('span', {
    staticClass: "element-title-text"
  }, [_vm._v("Motivating A Monster")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-volume-group has-volume-author has-no-children"
  }, [_c('div', {
    staticClass: "toc-item toc-item-element-bodymatter toc-item-element-type-volume has-no-leading-number has-no-children has-no-page-number"
  }, [_c('p', {
    staticClass: "volume-author"
  }, [_vm._v("James A. Hearn")]), _vm._v(" "), _c('p', {
    staticClass: "element-title"
  }, [_c('a', {
    attrs: {
      "href": "#/vol019"
    }
  }, [_c('span', {
    staticClass: "element-title-text"
  }, [_vm._v("Tunnel Visions")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-volume-group has-volume-author has-no-children"
  }, [_c('div', {
    staticClass: "toc-item toc-item-element-bodymatter toc-item-element-type-volume has-no-leading-number has-no-children has-no-page-number"
  }, [_c('p', {
    staticClass: "volume-author"
  }, [_vm._v("Ryan F. Healey")]), _vm._v(" "), _c('p', {
    staticClass: "element-title"
  }, [_c('a', {
    attrs: {
      "href": "#/vol020"
    }
  }, [_c('span', {
    staticClass: "element-title-text"
  }, [_vm._v("Our Lady of Celluloid")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-volume-group has-volume-author has-no-children"
  }, [_c('div', {
    staticClass: "toc-item toc-item-element-bodymatter toc-item-element-type-volume has-no-leading-number has-no-children has-no-page-number"
  }, [_c('p', {
    staticClass: "volume-author"
  }, [_vm._v("Karina Fabian")]), _vm._v(" "), _c('p', {
    staticClass: "element-title"
  }, [_c('a', {
    attrs: {
      "href": "#/vol021"
    }
  }, [_c('span', {
    staticClass: "element-title-text"
  }, [_vm._v("Josie’s Last Straw")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-volume-group has-volume-author has-no-children"
  }, [_c('div', {
    staticClass: "toc-item toc-item-element-bodymatter toc-item-element-type-volume has-no-leading-number has-no-children has-no-page-number"
  }, [_c('p', {
    staticClass: "volume-author"
  }, [_vm._v("B.D. Prince")]), _vm._v(" "), _c('p', {
    staticClass: "element-title"
  }, [_c('a', {
    attrs: {
      "href": "#/vol022"
    }
  }, [_c('span', {
    staticClass: "element-title-text"
  }, [_vm._v("The Last Drive-in Movie")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-volume-group has-volume-author has-no-children"
  }, [_c('div', {
    staticClass: "toc-item toc-item-element-bodymatter toc-item-element-type-volume has-no-leading-number has-no-children has-no-page-number"
  }, [_c('p', {
    staticClass: "volume-author"
  }, [_vm._v("Fran Wilde")]), _vm._v(" "), _c('p', {
    staticClass: "element-title"
  }, [_c('a', {
    attrs: {
      "href": "#/vol023"
    }
  }, [_c('span', {
    staticClass: "element-title-text"
  }, [_vm._v("Welcome to the Underhill Cinema")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-backmatter-group"
  }, [_c('div', {
    staticClass: "toc-item toc-item-element-non-bodymatter toc-item-element-type-none has-no-leading-number has-no-children has-no-page-number"
  }, [_c('p', {
    staticClass: "element-title"
  }, [_c('a', {
    attrs: {
      "href": "#/additionalcopyrightinformation"
    }
  }, [_c('span', {
    staticClass: "element-title-text"
  }, [_vm._v("Additional Copyright Information")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-element-non-bodymatter toc-item-element-type-about-author has-no-leading-number has-no-children has-no-page-number"
  }, [_c('p', {
    staticClass: "element-title"
  }, [_c('a', {
    attrs: {
      "href": "#/abouttheeditor"
    }
  }, [_c('span', {
    staticClass: "element-title-text"
  }, [_vm._v("About the Editor")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-element-non-bodymatter toc-item-element-type-also-by has-no-leading-number has-no-children has-no-page-number"
  }, [_c('p', {
    staticClass: "element-title"
  }, [_c('a', {
    attrs: {
      "href": "#/ifyouliked"
    }
  }, [_c('span', {
    staticClass: "element-title-text"
  }, [_vm._v("If You Liked …")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-element-non-bodymatter toc-item-element-type-also-by has-no-leading-number has-no-children has-no-page-number"
  }, [_c('p', {
    staticClass: "element-title"
  }, [_c('a', {
    attrs: {
      "href": "#/otherwordfirepressanthologies"
    }
  }, [_c('span', {
    staticClass: "element-title-text"
  }, [_vm._v("Other WordFire Press Anthologies")])])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-624f1122","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/contents.vue
// module id = 72
// module chunks = 0